import React, { useState } from 'react';
import useManageUser from './useManageUser';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Register = () => {
  const { error, login } = useManageUser();

  const initialValue = {
    identifier: '',
    password: ''
  }

  const [user, setUser] = useState(initialValue)
  const navigate = useNavigate()
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleRegister = async (e) => {
    e.preventDefault()
    const returnResult = await login(user);

    // Check if login was successful
    if (returnResult && returnResult.success) {
        toast.success('Register Successfully');

        // Redirect based on user role
        if (returnResult.role === 'admin' || returnResult.role === 'superuser') {
            navigate('/keydata');
        } else {
            navigate('/sendonly');
        }
    } else {
      toast.error(error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md w-full space-y-8">
        <div>
        <img
          className="mx-auto h-60 w-auto"
          src="https://res.cloudinary.com/dkeybfbhj/image/upload/v1703700428/resources/ej6cuul9mgff3mnmxyfh.png"
          alt="Your Logo"
        />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Sign in to your account
          </h2>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleRegister} method="post">
          <div>
            <label htmlFor="identifier" className="sr-only">
              Email/ Phone No.
            </label>
            <input
              id="identifier"
              name="identifier"
              type="string"
              required
              value={user?.identifier}
              onChange={handleInputChange}
              className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
              placeholder="Username"
            />
          </div>
          <div>
            <label htmlFor="password" className="sr-only">
              Password
            </label>
            <input
              id="password"
              name="password"
              type="password"
              value={user?.password}
              onChange={handleInputChange}
              autoComplete="current-password"
              required
              className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
              placeholder="Password"
            />
          </div>
          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Register
            </button>
            <div className='h-60'></div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;
